import { PhoneValidator } from "./phoneValidator";

export const formatPhoneWithFallback = (phone: string): string => {
  try {
    return PhoneValidator.formatE164(phone, "CA");
  } catch {
    try {
      return PhoneValidator.formatE164(phone, "US");
    } catch (error) {
      throw new Error(`Invalid phone number: ${phone}`);
    }
  }
};
